import { useSelector, shallowEqual } from 'react-redux';
import { getConsultById } from 'Selectors/webChat/consults';


const useConsult = consultId => useSelector(
  state => getConsultById(state, consultId),
  shallowEqual,
);

export default useConsult;
